import { EdgelessTextBlockComponent } from './edgeless-text-block';

export function effects() {
  customElements.define('hive-edgeless-text', EdgelessTextBlockComponent);
}
